import { ExternalLink } from "lucide-react";
import { Button } from "./ui/button";

const GoogleMap = () => {
  return (
    <section className="py-20 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="text-primary text-sm font-semibold tracking-wider uppercase">
            Our Service Area
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mt-2 text-foreground">
            Serving San Antonio & Surrounding Areas
          </h2>
          <p className="text-muted-foreground text-lg mt-4 max-w-2xl mx-auto">
            Experience luxury transportation throughout the greater San Antonio metropolitan area. We proudly serve the <span className="font-semibold text-foreground">210 and 830 area codes</span>, covering all of Bexar, Comal, and Kendall counties.
          </p>
        </div>

        <div className="relative w-full h-[400px] rounded-lg overflow-hidden shadow-2xl border border-border">
          <iframe
            src="https://maps.google.com/maps?q=16034%20Rough%20Oak%20Street,%20San%20Antonio,%20TX%2078232&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Rick's Black Car Service - 16034 Rough Oak Street, San Antonio, TX 78232"
          ></iframe>
        </div>

        <div className="mt-8 text-center space-y-4">
          <p className="text-muted-foreground">
            <span className="font-semibold text-foreground">Rick's Black Car Service</span>
            <br />
            16034 Rough Oak Street, San Antonio, TX 78232
            <br />
            <a href="tel:+12102967409" className="text-primary hover:text-primary/80 transition-colors font-semibold text-lg">
              210-296-7409
            </a>
            <br />
            <span className="text-sm">Serving 210 & 830 Area Codes</span>
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto mt-6">
            <div className="text-center p-4 bg-card rounded-lg border border-border">
              <p className="font-semibold text-foreground">Bexar County</p>
              <p className="text-sm text-muted-foreground">210 Area Code</p>
            </div>
            <div className="text-center p-4 bg-card rounded-lg border border-border">
              <p className="font-semibold text-foreground">Comal County</p>
              <p className="text-sm text-muted-foreground">830 Area Code</p>
            </div>
            <div className="text-center p-4 bg-card rounded-lg border border-border">
              <p className="font-semibold text-foreground">Kendall County</p>
              <p className="text-sm text-muted-foreground">830 Area Code</p>
            </div>
          </div>

          <Button 
            variant="outline" 
            className="border-primary text-primary hover:bg-primary hover:text-primary-foreground mt-4"
            asChild
          >
            <a href="https://share.google/5T2Nf3VRTleu3sBWA" target="_blank" rel="noopener noreferrer">
              <ExternalLink className="w-4 h-4 mr-2" />
              View on Google Maps
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default GoogleMap;